<template>
    <div>
        <div class="p-2 mb-5">
            <v-card-text
              class="p-4 mb-5"
              id="configuration"
            >
                <h4 class="mb-5">Personnalisation du formulaire</h4>
                <div class="d-flex justify-content-between">
                    <div
                      style="width: 320px"
                      class="position-relative"
                    >
                        <div class="d-flex gap-10 align-items-end mb-3">
                            <h5>Styles</h5>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      icon
                                      @click="resetStyle"
                                    >
                                        <v-icon color="primary">mdi-reload</v-icon>
                                    </v-btn>
                                </template>
                                <span>Réinitialiser tous les styles</span>
                            </v-tooltip>
                        </div>

                        <div class="mb-5 valid-button">
                            <div class="title-valid-button">Couleurs</div>

                            <div class="py-4 pb-0">
                                <div class="row">
                                    <div class="col p-0">
                                        <div
                                          class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + cadhPrimaryColor"
                                              @click="openColorDialog('cadhPrimaryColor')"
                                            ></div>
                                            <v-label>Primaire</v-label>
                                        </div>
                                    </div>
                                    <div class="col p-0">
                                        <div
                                          class="d-flex mb-7 color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + cadhTitlesColor"
                                              @click="openColorDialog('cadhTitlesColor')"
                                            ></div>
                                            <v-label>Titres</v-label>
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col">
                                        <div
                                          class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + cadhFieldsColor"
                                              @click="openColorDialog('cadhFieldsColor')"
                                            ></div>
                                            <v-label>Nom des champs</v-label>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div
                                          class="d-flex color-editor-div justify-content-center align-items-center flex-column text-center"
                                        >
                                            <div
                                              class="color-editor mb-3"
                                              :style="'background-color:' + cadhBackGroundColorRgba"
                                              @click="openColorDialog('cadhBackGroundColor')"
                                            ></div>
                                            <v-label>Fond</v-label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex mb-5 color-editor-div">
                            <v-select
                              :items="availableFonts"
                              outlined
                              label="Police d'écriture"
                              v-model="cadhFontFamily"
                              @change="setCadhFontFamily"
                              return-object
                            >
                            </v-select>
                        </div>
                    </div>

                    <div style="width: calc(100% - 350px)">
                        <div class="d-flex gap-10 align-items-end mb-5" v-if="token !== null">
                            <h5>Prévisualiser</h5>

                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                      v-on="on"
                                      icon
                                      @click="preparePreview"
                                    >
                                        <v-icon color="primary">open_in_new</v-icon>
                                    </v-btn>
                                </template>
                                <span>Voir le formulaire complet</span>
                            </v-tooltip>
                        </div>

                        <div
                          class="web-form-simulation"
                          id="pro-layout"
                          style="min-height: auto !important"
                          :style="'background-color:' + cadhBackGroundColorRgba + ';font-family:' + cadhFontFamily"
                        >
                            <div id="pro-cmaj-form">
                                <div class="tabulation-title">
                                    <h5 :style="'color:' + cadhTitlesColor">Nos offres</h5>
                                </div>

                                <div class="mt-3">
                                    <v-card class="cadh-offer-card mt-5 mb-5" width="340px">
                                        <v-app-bar dark :color="cadhPrimaryColor" class="offer-toolbar">
                                            <div class="d-flex justify-content-between offer-title w-100">
                                                <div :style="'font-family:' + cadhFontFamily">Offre 1</div>
                                            </div>
                                        </v-app-bar>

                                        <v-card-text style="font-size: 16px" class="bg-white">
                                            <div class="d-flex justify-content-between">
                                                <div class="text-center mt-auto mb-auto">
                                <span>
                                    120 €
                                </span>
                                                </div>

                                                <v-btn class="cadh-offer-button text-none mt-auto mb-auto"
                                                       :style="'background-color:' + cadhPrimaryColor + '!important'">
                                                    Ajouter
                                                </v-btn>
                                            </div>
                                        </v-card-text>
                                    </v-card>

                                    <div class="tabulation-title">
                                        <h5 :style="'color:' + cadhTitlesColor">Nos options</h5>
                                    </div>

                                    <div class="form-container mr-auto ml-auto mt-3">
                                        <v-card class="mt-3 w-auto">
                                            <v-card-text>
                                                <div class="mb-3 d-flex justify-content-between">
                                                    <div class="mt-auto mb-auto option-label">
                                                        <span style="font-size: 16px">Encart sur la première page de notre guide</span>
                                                    </div>

                                                    <div class="mt-auto mb-auto price" style="font-size: 16px">
                                                        <div>
                                                            120 €
                                                        </div>
                                                    </div>

                                                    <div class="mt-auto mb-auto">
                                                        <v-btn class="default-button text-none mt-auto mb-auto"
                                                               :style="'background-color:' + cadhPrimaryColor + '!important'">
                                                            Ajouter
                                                        </v-btn>
                                                    </div>
                                                </div>
                                            </v-card-text>
                                        </v-card>
                                    </div>


                                    <div class="tabulation-title">
                                        <h5 style="font-size: 22px" :style="'color:' + cadhTitlesColor">
                                            Informations de la personne répondant
                                        </h5>
                                    </div>

                                    <div class="d-flex justify-content-between mt-3">
                                        <div class="flex-grow-1 mr-3">
                                            <label class="custom-label required"
                                                   :style="'color:' + cadhFieldsColor">
                                                Prénom
                                            </label>
                                            <v-text-field
                                              hide-details
                                              outlined>
                                            </v-text-field>
                                        </div>
                                        <div class="flex-grow-1 ml-3">
                                            <label class="custom-label required"
                                                   :style="'color:' + cadhFieldsColor">
                                                Nom
                                            </label>
                                            <v-text-field
                                              hide-details
                                              outlined>
                                            </v-text-field>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </div>

        <v-dialog
          v-model="dialogHexa"
          max-width="300px"
          v-if="dialogHexa"
          content-class="color-picker-dialog"
        >
            <v-color-picker
              dot-size="25"
              v-model="currentColor"
              mode="hexa"
              @input="updateColor"
              swatches-max-height="200"
            >
            </v-color-picker>
        </v-dialog>

        <v-dialog
          v-model="dialogRgba"
          max-width="300px"
          v-if="dialogRgba"
          content-class="color-picker-dialog"
        >
            <v-color-picker
              dot-size="25"
              v-model="currentColor"
              mode="rgba"
              @input="updateColor"
              swatches-max-height="200"
            >
            </v-color-picker>
        </v-dialog>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "CadhFormConfigStepper",
    props: ["token"],
    data() {
        return {
            dialogHexa: false,
            dialogRgba: false,
            currentColor: null,
            currentProperty: null,
        }
    },
    methods: {
        ...mapMutations("webFormStyle", [
            "setCadhFontFamily",
            "setCadhTitlesColor",
            "setCadhBackGroundColor",
            "setCadhPrimaryColor",
            "setCadhFieldsColor",
        ]),
        openColorDialog(vmProperty) {
            this.currentColor = this[vmProperty]
            this.currentProperty = vmProperty

            if (vmProperty === "cadhBackGroundColor") {
                if (typeof this.currentColor !== "object") {
                    this.currentColor = this.rgbaStringToObject(this.currentColor)
                    this.setCadhBackGroundColor(this.currentColor)
                }

                this.dialogRgba = true
            } else {
                this.dialogHexa = true
            }
        },
        updateColor(value) {
            if (this.currentProperty === "cadhFieldsColor") {
                this.setCadhFieldsColor(value)
            } else if (this.currentProperty === "cadhBackGroundColor") {
                this.setCadhBackGroundColor(value)
            } else if (this.currentProperty === "cadhTitlesColor") {
                this.setCadhTitlesColor(value)
            } else if (this.currentProperty === "cadhPrimaryColor") {
                this.setCadhPrimaryColor(value)
            }
        },
        resetStyle() {
            this.setCadhPrimaryColor("#1398b5")
            this.setCadhTitlesColor("#000000")
            this.setCadhFieldsColor("#787d8f")
            this.setCadhFontFamily("Roboto, sans-serif")
            this.setCadhBackGroundColor({
                r: 245,
                b: 245,
                g: 245,
                a: 1,
            })
        },
        preparePreview() {
            if (typeof this.cadhBackGroundColor !== "object") {
                this.setCadhBackGroundColor(this.rgbaStringToObject(this.cadhBackGroundColor))
            }
            this.setCadhBackGroundColor(this.cadhBackGroundColorRgba)

            let jsonStyles = JSON.stringify({
                "background": this.cadhBackGroundColor,
                "title": this.cadhTitlesColor,
                "field": this.cadhFieldsColor,
                "primary": this.cadhPrimaryColor,
                "font": this.cadhFontFamily,
            })

            let route = this.$router.resolve({ path: "/cadh-preview/" + this.token, query: { style: jsonStyles } })

            window.open(route.href, "_blank")
        },
        rgbaStringToObject(backGroundColor) {
            let colors = ["r", "g", "b", "a"]

            let colorArr = backGroundColor.slice(backGroundColor.indexOf("(") + 1, backGroundColor.indexOf(")")).split(",")

            let obj = {}

            colorArr.forEach((k, i) => {
                obj[colors[i]] = k
            })

            return obj
        },
    },
    computed: {
        ...mapState("account", ["account"]),
        ...mapState("webFormStyle", [
            "cadhFontFamily",
            "cadhTitlesColor",
            "cadhBackGroundColor",
            "cadhPrimaryColor",
            "cadhFieldsColor",
            "availableFonts",
        ]),
        cadhBackGroundColorRgba() {
            return (
              "rgba(" +
              this.cadhBackGroundColor.r +
              "," +
              this.cadhBackGroundColor.g +
              "," +
              this.cadhBackGroundColor.b +
              "," +
              this.cadhBackGroundColor.a +
              ")"
            )
        },
    },
}
</script>
